export enum OAuthState {
  Pending,
  Authorized,
  Denied,
  PriorAuthorization,
}
